import {Instance, types} from 'mobx-state-tree';

export const Pagination = types.model({
  currentPage: types.number,
  totalPages: types.number,
  pageSize: types.number,
  totalCount: types.number,
  hasPrevious: types.boolean,
  hasNext: types.boolean,
});

export type PaginationType = Instance<typeof Pagination>;
